import * as React from "react";

const SvgRideUpdate = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_8932_20359"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8932_20359)">
        <path
          d="M3.3335 17.8513C3.3335 17.7128 3.34247 17.5744 3.36043 17.4359C3.37838 17.2974 3.40958 17.1658 3.45403 17.041L6.0566 9.66669C6.15573 9.36071 6.33777 9.11755 6.60273 8.93722C6.86769 8.75687 7.16255 8.66669 7.48733 8.66669H12.4668C12.7502 8.66669 12.9877 8.76257 13.1793 8.95432C13.371 9.14608 13.4668 9.38368 13.4668 9.66712C13.4668 9.95059 13.371 10.188 13.1793 10.3795C12.9877 10.5709 12.7502 10.6667 12.4668 10.6667H7.82576L6.1437 15.436H16.3335C16.6168 15.436 16.8543 15.5318 17.046 15.7236C17.2376 15.9153 17.3335 16.1529 17.3335 16.4364C17.3335 16.7198 17.2376 16.9573 17.046 17.1487C16.8543 17.3402 16.6168 17.4359 16.3335 17.4359H5.33346V24H24.0001V19.2615C24.0001 18.9782 24.096 18.7407 24.2878 18.549C24.4795 18.3573 24.7171 18.2615 25.0006 18.2615C25.284 18.2615 25.5215 18.3573 25.7129 18.549C25.9044 18.7407 26.0001 18.9782 26.0001 19.2615V27.2564C26.0001 27.6481 25.8628 27.9811 25.5883 28.2553C25.3138 28.5295 24.9805 28.6666 24.5884 28.6666C24.1962 28.6666 23.8634 28.5295 23.5899 28.2553C23.3164 27.9811 23.1797 27.6481 23.1797 27.2564V26H6.15393V27.2564C6.15393 27.6481 6.01669 27.9811 5.7422 28.2553C5.46768 28.5295 5.13436 28.6666 4.74223 28.6666C4.35007 28.6666 4.01725 28.5295 3.74376 28.2553C3.47025 27.9811 3.3335 27.6481 3.3335 27.2564V17.8513ZM20.7211 22.4615C21.2063 22.4615 21.6176 22.2917 21.9553 21.9521C22.2929 21.6125 22.4617 21.2001 22.4617 20.7149C22.4617 20.2298 22.2919 19.8184 21.9522 19.4808C21.6126 19.1432 21.2002 18.9744 20.7151 18.9744C20.2299 18.9744 19.8185 19.1442 19.4809 19.4838C19.1433 19.8234 18.9745 20.2358 18.9745 20.721C18.9745 21.2061 19.1443 21.6175 19.4839 21.9551C19.8236 22.2927 20.2359 22.4615 20.7211 22.4615ZM8.61853 22.4615C9.10368 22.4615 9.51506 22.2917 9.85266 21.9521C10.1903 21.6125 10.3591 21.2001 10.3591 20.7149C10.3591 20.2298 10.1893 19.8184 9.84966 19.4808C9.51004 19.1432 9.09765 18.9744 8.6125 18.9744C8.12734 18.9744 7.71595 19.1442 7.37833 19.4838C7.04073 19.8234 6.87193 20.2358 6.87193 20.721C6.87193 21.2061 7.04174 21.6175 7.38136 21.9551C7.72098 22.2927 8.13337 22.4615 8.61853 22.4615Z"
          fill="#1C1B1F"
        />
      </g>
      <circle
        cx="22.6666"
        cy="10.6666"
        r="5.33333"
        fill="white"
        stroke="#181818"
        strokeWidth="1.5"
      />
      <mask
        id="mask1_8932_20359"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="16"
        y="4"
        width="13"
        height="13"
      >
        <circle cx="22.6666" cy="10.6666" r="5.33333" fill="white" stroke="#181818" />
      </mask>
      <g mask="url(#mask1_8932_20359)">
        <path
          d="M23.0473 9.6459L24.1057 7.8356L20.239 8.81369L21.2834 12.6631L22.3417 10.8528C24.3737 12.0408 25.0761 14.6295 23.9083 16.6268C23.552 17.2363 23.0599 17.7258 22.4908 18.0652L22.872 19.4702C23.7848 19.0079 24.5822 18.292 25.1361 17.3446C26.6955 14.6775 25.7607 11.2323 23.0473 9.6459Z"
          fill="#181818"
          stroke="#181818"
          strokeWidth="0.5"
        />
      </g>
    </svg>
  );
};

export default SvgRideUpdate;
